import { IPaymentMethod, RootState } from '@checkout/state';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { KlarnaCheckout } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { walletMethods } from '../../../config/contextCheckoutConfig';
import { Section } from '../../presentational';
import * as Styles from './Wallet.scss';

interface IOwnProps {}

interface IConnectedProps {
  paymentMethods: IPaymentMethod[];
}

type Props = IOwnProps & IConnectedProps;

class Wallet extends React.Component<Props, {}> {

  render() {
    const { paymentMethods } = this.props;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.wallet}>
            {checkoutContextConfig.modules.wallet.isEnabled && paymentMethods.map((item: IPaymentMethod) => {
              if (item.paymentMethod && item.paymentMethod.includes(checkoutContextConfig.modules.wallet.method)) {
                return (
                  <Section key={item.paymentMethod}>
                  {checkoutContextConfig.modules.wallet.isEnabled &&
                    checkoutContextConfig.modules.wallet.method === walletMethods.klarnaCheckout && (
                      <KlarnaCheckout />
                    )}
                  </Section>
                );
              }
              return <div key={item.paymentMethod} />;
            })}
          </div>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps>(
    (state: RootState) => ({
      paymentMethods: state.checkout.paymentMethods,
    })
  ),
)(Wallet);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Wallet/Wallet.tsx